module.exports = __webpack_public_path__ + "img/mashal.d93512c.png";